module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_WFP_ChapHead",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Book Description")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText"
  }, [_c('i', [_vm._v("The Cadet")]), _vm._v(", Book 1 of the Wild Blue U saga, chronicles the founding years of arduous training of America’s future leaders as they prepare to serve in such places from the jungles of Vietnam to the deserts of the Middle East. "), _c('i', [_vm._v("The Cadet")]), _vm._v(" is an accurate, historical saga of the Academy based on factual events—but populated with empathetic, larger-than-life characters that will appeal to prospective candidates, military members, and the reading public alike.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34a0e764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0001.vue
// module id = 60
// module chunks = 0